// Channel 상수
export const CHANNELS = [
  "adjust",
  "airbridge",
  "amazon_dsp",
  "amplitude",
  "apple",
  "appsflyer",
  "branch",
  "cafe24",
  "cafe24_admin",
  "criteo",
  "dv360",
  "facebook",
  "google",
  "google_analytics_v4",
  "kakao",
  "kakao_keywordad",
  "karrot",
  "mobon",
  "moloco",
  "naver",
  "naver_brandstore",
  "naver_gfa",
  "naver_nosp",
  "reddit",
  "remerge",
  "rtbhouse",
  "snapchat",
  "targeting_gates",
  "tiktok",
  "twitter",
  "yahoo",
] as const;

export type Channel = (typeof CHANNELS)[number];
